import { 
    apiGetIncomeAndExpenditure
    } from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_income_expenditure_list: 'financiaManagement/set_income_expenditure_list',
    set_mode: 'financiaManagement/set_mode',
    set_filter_query: 'financiaManagement/set_filter_query',
    set_filter_word: 'financiaManagement/set_filter_word',
    set_filter_result_total: 'financiaManagement/set_filter_result_total',
    set_filter_default: 'financiaManagement/set_filter_default',
    set_loading: 'financiaManagement/set_loading'

}

// count state 必須是 Object
const state = {
    incomeAndExpemditureList: [],
    filterQuery: {
        houseName: null,
        type: null,
        amount: [0, 100000],
        source: null,
    },
    filterWord: '',
    filterResultTotal: '',
    mode: null,
    isDefault: true,
    isLoading: false
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_INCOME_EXPENDITURE_MGT_LIST: (state) => {
        return state.incomeAndExpemditureList
    },
    GET_INCOME_EXPENDITURE_MGT_MODE: (state) => {
        return state.mode
    },
    GET_INCOME_EXPENDITURE_MGT_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_INCOME_EXPENDITURE_MGT_FILTER_WORD: (state) => {
        return state.filterWord
    },
    GET_INCOME_EXPENDITURE_MGT_FILTER_RESULT_TOTAL: (state) => {
        // console.log(state.filterResultTotal)
        return state.filterResultTotal
    },
    GET_INCOME_EXPENDITURE_HOUSE_NAME_IS_EMPTY: (state) => {
        if( state.filterQuery.houseName == null ){
            return true
        }else{
            return false
        }
    },
    GET_INCOME_EXPENDITURE_TYPE_IS_EMPTY: (state) => {
        if( state.filterQuery.type == null ){
            return true
        }else{
            return false
        }
    },
    GET_INCOME_EXPENDITURE_SOURCE_IS_EMPTY: (state) => {
        if( state.filterQuery.source == null ){
            return true
        }else{
            return false
        }
    },
    GET_INCOME_EXPENDITURE_FILTER_WORD_IS_EMPTY: (state) => {
        if( state.filterWord == '' ){
            return true
        }else{
            return false
        }
    },
    GET_INCOME_EXPENDITURE_MGT_FILTER_DEFAULT: (state) => {
        return state.isDefault
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getIncomeAndExpenditureMgtList ( {commit} ) {
        return new Promise((resolve, reject) => {
            commit(types.set_loading, true);
            apiGetIncomeAndExpenditure()
            .then(res => {
                // console.log(res)
                commit(types.set_loading, false);
                if( res.data.status == "SUCCESS" ){
                    console.log(res)
                    commit(types.set_income_expenditure_list, res.data.result);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    setIncomeFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
    setIncomeFilterWord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_word, value);
            resolve()
        })
    },
    setIncomeFilterResultTotal ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_result_total, value);
            resolve()
        })
    },
    setIncomeFilterDefault ( {commit} ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_default);
            resolve()
        })
    },
    // setHouseMgtMode ( {commit}, data ) {
    //     return new Promise((resolve, reject) => {
    //         commit(types.set_mode, data);
    //         resolve()
    //     })
    // }
}

// mutations
const mutations = {
    [types.set_income_expenditure_list](state, data){
        state.incomeAndExpemditureList = data
    },
    [types.set_mode](state, data){
        state.mode = data
    },
    [types.set_filter_word](state, data){
        state.filterWord = data
        state.isDefault = false
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.isDefault = false
    },
    [types.set_filter_result_total](state, data){
        state.filterResultTotal = data
    },
    [types.set_filter_default](state){
        state.filterQuery.houseName = null
        state.filterQuery.type = null
        state.filterQuery.amount = [0, 100000]
        state.filterQuery.source= null
        state.filterWord = null
        setTimeout(()=>{
            state.isDefault = true
        },100)
    },
    [types.set_loading](state, data){
        state.isLoading = data
    }
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/landlord/financialManagement.js